export class ThematicFolderDto {
  thematicFolderId: number;
  titleFrancais: string;
  titleAnglais: string;
  pathFolder: string;
  pathImage: string;
  urlImage: string;
  parentId: number;
}
